export default __webpack_public_path__ + "static/media/image-work-team-w@2x.bb50df37.webp";